import { FC, useCallback, useEffect } from 'react';
import { css } from '@emotion/react';
import { FormsV1 } from '@frontend/api-digital-forms';
import { theme } from '@frontend/theme';
import { ContentLoader } from '@frontend/design-system';
import { useVerifyOTP } from '../../../../../hooks/api-hooks/use-verify-otp';
import Footer from '../../../../layout/footer.component';

const cardStyle = css`
  background-color: ${theme.colors.white};
  padding: ${theme.spacing(2)};
  border-radius: ${theme.borderRadius.medium};
  box-shadow: ${theme.shadows.floating};
`;

interface Props {
  secretCode: string;
  qwe: string;
  companyId: string;
  onSuccess: (
    data: Pick<
      FormsV1.Types.GetFormTemplateIO['output'],
      'personDetails' | 'medicalHistory' | 'prePopulateElements' | 'primaryInsurance' | 'secondaryInsurance'
    >
  ) => void;
  onFillManually: () => void;
}

export const VerifySecretCode: FC<Props> = ({ secretCode, qwe, companyId, onSuccess, onFillManually }) => {
  const { verifyOTP } = useVerifyOTP(qwe, companyId);

  const validateSecretCode = useCallback(async () => {
    const res = await verifyOTP(secretCode);
    if (res.success && res.data) {
      onSuccess(res.data);
    } else {
      // don't show error message if invalid otp or server error  and redirect to fill form manually
      onFillManually();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    validateSecretCode();
  }, [validateSecretCode]);

  return (
    <>
      <div css={cardStyle}>
        <ContentLoader show />
      </div>
      <Footer />
    </>
  );
};
